/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// TODO fix and remove eslint disables
import { db } from '../../Firebase';
import { orderBy, query, doc, setDoc, deleteDoc, collection as fbCollection, CollectionReference, } from 'firebase/firestore';
import { collectionData } from 'rxfire/firestore';
import { tap, Observable, shareReplay, switchMap, map, catchError, of, withLatestFrom, combineLatest, } from 'rxjs';
import { VoteArrayT } from '../../shared/codecs/Vote';
import { authed_user } from '../../Users/observables';
import { decodeWithOrError } from '../../rxjs/Decode';
import { update_last_seen } from '../../Players/observables';
export const current_votes = authed_user.pipe(switchMap(user => {
    const collection = query(fbCollection(db, 'organizations', user.organization, 'current_votes'), orderBy('color'));
    return collectionData(collection).pipe(decodeWithOrError(VoteArrayT), catchError(err => {
        if (err instanceof Error) {
            console.error('Error thrown while decoding the Votes, returning empty array');
        }
        return of([]);
    }), tap((votes) => console.log(`votes ${votes.length}`)), shareReplay(1));
}), shareReplay(1));
export const vote = authed_user.pipe(withLatestFrom(update_last_seen), map(([user, update_last_seen]) => {
    const user_vote_doc = doc(db, 'organizations', user.organization, 'current_votes', user.uid);
    return async (vote) => {
        console.log('voting');
        await update_last_seen();
        return setDoc(user_vote_doc, {
            player: user.uid,
            color: vote,
        });
    };
}), shareReplay(1));
export const votes_collection = authed_user.pipe(map(user => fbCollection(db, 'organizations', user.organization, 'current_votes')), shareReplay(1));
export const reset_votes = combineLatest([
    current_votes,
    votes_collection,
]).pipe(map(([current_votes, votes_collection]) => async () => {
    return Promise.all(current_votes.map(vote => deleteDoc(doc(votes_collection, vote.player))));
}), shareReplay(1));
